"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const globalSettingsTranslations = {
    securitySettings: "Security Settings",
    about: "About",
};
exports.default = globalSettingsTranslations;
